import { createSlice } from "@reduxjs/toolkit";
import { sendUserActivityLog } from "../thunks/userActivityLogThunk";

const userActivityLogSlice = createSlice({
  name: "userActivityLog",
  initialState: { logs: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sendUserActivityLog.pending, (state) => {
        state.loading = true;
      })
      .addCase(sendUserActivityLog.fulfilled, (state, action) => {
        state.loading = false;
        state.logs.push(action.payload); // Store logs in Redux for reference
      })
      .addCase(sendUserActivityLog.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default userActivityLogSlice.reducer;
